import { initializeApp } from 'firebase/app';
import VueYoutube from 'vue-youtube';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Vue.use(VueYoutube);

const firebaseConfig = {
  apiKey: 'AIzaSyDRHbqwbpGB6B6JTQVc-cnrmZYozoKtAPA',
  authDomain: 'oropos-jukebox.firebaseapp.com',
  projectId: 'oropos-jukebox',
  storageBucket: 'oropos-jukebox.appspot.com',
  messagingSenderId: '164023923985',
  appId: '1:164023923985:web:2ebdcb212c7663837bc8b0',
};

initializeApp(firebaseConfig);
